<template>

<b-container fluid>
  <b-form-row>
    <b-col>
      <b-form-row class="items-gap">
        <div class="form-group">
          <model-select v-model="filters.user" :model-request="loadUsers" label="Operario" model-label="name" placeholder="Buscar por nombre"/>
        </div>
        <div class="form-group">
          <label>Desde
            <b-form-input type="date" v-model="filters.from"/>
          </label>
        </div>
        <div class="form-group">
          <label>Hasta
            <b-form-input type="date" v-model="filters.to"/>
          </label>
        </div>
      </b-form-row>
    </b-col>
    <b-col cols="auto" class="d-flex flex-column justify-content-center pr-4">
      <b-button @click="$emit('click-search')" variant="primary" block>Buscar</b-button>
      <b-button @click="onClickExport" variant="info" block>Exportar</b-button>
      <b-button @click="clean" variant="secondary" block>Limpiar</b-button>
    </b-col>
  </b-form-row>
</b-container>

</template>

<script>

import api from '@/api/api'
import ModelSelect from '@/components/common/ModelSelect'

export default {
  name: 'LaborRegistryFilter',
  components: {ModelSelect},
  model: {prop: 'filters'},
  props: {
    filters: {type: Object, required: true}
  },
  data() {
    return {
    }
  },
  methods: {
    loadUsers(name = null) {
      return api.appUser.index({name, size: 100, sort: 'name'}).then(paginator => paginator.content)
    },
    clean() {
      this.inicializaFechas()
      this.filters.user = null
      this.$emit('click-search')
    },
    onClickExport() {
      api.workOrder.exportTimeRecords(this.filters)
    },
    inicializaFechas() {
      var hoy = new Date()
      var primerDiaMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1)
      this.filters.from = this.formateaFecha(primerDiaMes)
      var ultimoDiaMes = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0)
      this.filters.to = this.formateaFecha(ultimoDiaMes)
    },
    formateaFecha(date) {
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var dt = date.getDate()
      if (dt < 10) {
        dt = '0' + dt
      }
      if (month < 10) {
        month = '0' + month
      }
      return year + '-' + month + '-' + dt
    }
  },
  created() {
  }
}

</script>



// WEBPACK FOOTER //
// src/components/laborRegistry/partials/LaborRegistryFilter.vue